export default "42a1b11f19571b09.svg"